import React from "react";

import RoomService from "./rooms-service";
import SocketService from "./socket";
import PlaylistService from "./playlist-service";
import { ModalTypes, ModalService } from "./modal-service";
import { PlaylistModal, PlaylistsModal, OptionsModal } from "../modals";
import { addToQueue } from "./utils";
import ImportModal from "../module/import";

import { faGlobeAsia, faStream } from "@fortawesome/free-solid-svg-icons";

const AddSongFlow = class {
  constructor() {
    this.type = null;
    this.addSongs = null;
    this.id = null;
  }

  initiateAddToPlaylist({ songs, onAdd }) {
    const onSelect = async (id) => {
      ModalService.closeModal();
      await PlaylistService.addSongs({ id, songs });
      if (onAdd && typeof onAdd === "function") onAdd();
    };
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "500px",
      content: <PlaylistsModal onSelect={onSelect} />,
    });
  }

  // add to playlist, room, queue
  // step 1: set functions
  initiate({ type, id, onAdd }) {
    this.type = type;
    this.id = id;
    console.log("type is", type);
    switch (type) {
      case "playlist":
        this.addSongs = async (songs) => {
          const isAdded = await PlaylistService.addSongs({ id, songs });
          if (onAdd && typeof onAdd === "function") onAdd();
          return isAdded;
        };
        break;
      case "room":
        this.addSongs = async (songs) => {
          if (songs && songs.length > 0) {
            const isAdded = await RoomService.add({ roomId: id, songs });
            if (onAdd && typeof onAdd === "function") onAdd();
            return isAdded;
          }
        };
        break;
      case "queue":
        this.addSongs = async (songs) => {
          addToQueue({ songs });
          if (onAdd && typeof onAdd === "function") onAdd();
          return true;
        };
        break;
    }
    this.showOptions();
  }

  // step 2 : import from playlist or web
  showOptions = () => {
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "140px",
      content: (
        <OptionsModal
          title={`Add songs to ${this.type}`}
          buttons={[
            {
              name: "import from playlist",
              icon: faStream,
              onClick: this.showPlaylists,
            },
            {
              name: "import from web",
              icon: faGlobeAsia,
              onClick: this.showImportWeb,
            },
          ]}
        />
      ),
    });
  };

  // step 4 : show songs
  showPlaylist(id) {
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "40%",
      height: "400px",
      content: (
        <PlaylistModal
          id={id}
          addSongs={this.addSongs}
          onBack={this.showPlaylists}
        />
      ),
    });
  }

  // step 3 : show playlists
  showPlaylists = () => {
    const onSelect = (id) => {
      this.showPlaylist(id);
    };
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "500px",
      content: <PlaylistsModal onSelect={onSelect} />,
    });
  };

  showImportWeb = () => {
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "90%",
      height: "90%",
      content: (
        <ImportModal
          modalData={{ to: this.type, handleAddSongs: this.addSongs }}
        />
      ),
    });
  };
};
const instance = new AddSongFlow();

export default instance;
